<template>
  <v-text-field v-if="url"
                :value="embedTag ?? url"
                :label="label"
                :hint="hint"
                :persistent-hint="persistentHint"
                readonly
                outlined
                dense
                @focus="selectText($event)"
                class="mb-4">
    <template v-slot:append>
      <v-btn icon
             style="margin-top: -8px;"
             @click.prevent="copyURL">
        <v-icon>
          fas fa-fw fa-copy
        </v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>
<script>
import {isString} from 'lodash';
import clipboardService from '../../../../../ml/services/clipboardService';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
    hint: {
      type: String,
      required: false,
    },
    embed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    embedTag() {
      if (this.embed) {
        return `<iframe width="560" height="315" src="${this.link.embed_url}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      }
    },
    persistentHint() {
      return isString(this.hint) && this.hint.trim().length > 0;
    }
  },
  methods: {
    selectText(event) {
      // Ensure the event target is an input element
      if (event.target.tagName === 'INPUT') {
        // Delay the selection to ensure the element has focus
        this.$nextTick(() => {
          event.target.select();
        });
      }
    },
    copyURL() {
      if (this.embed) {
        clipboardService.copy(this.embedTag)
            .then(() => {
              this.$toast.success('Embed code copied to clipboard.');
            })
            .catch(() => {

            })
      } else {
        clipboardService.copy(this.url)
            .then(() => {
              this.$toast.success('URL copied to clipboard.');
            })
            .catch(() => {

            })
      }
    }
  }
}
</script>
